import React from 'react';
import '../styles/App.css';

/**
 * Class used to render rpo questions selections for NAOVin and GMEVin
 *
 * @author Ethan Jones
 */
class RpoTable extends React.Component {

    state = {
        additionalRpoIndices: null,
        additionalRpoLocations: null,
        additionalRpoQuestions: null,
        isSingleRpo: null,
        gmeRpoTables: [],
    }

    constructor(props){console.log("Entered the constructor")
        super(props)
        this.state.additionalRpoIndices = this.props.additionalRpoIndices
        this.state.additionalRpoQuestions = this.props.additionalRpoQuestions
        this.additionalRpoHandler = this.additionalRpoHandler.bind(this)
    }
    /**
     * Iterates through the RPO questions for NAOVin and displays them
     * @returns {*}
     */
    renderRpoQuestionsWsp(){
        return(
                this.props.postRpoQuestions && this.props.postRpoQuestions.map((data, index) =>
                <tr key={data}>
                    <td id={"rpo"+index} onClick={()=> this.props.handleRpoQuestionClickWsp(data, index)}
                        className={this.props.postRpoIndex === index ? "selectedRow" :"rpoTableRow"}>{data}</td>
                </tr>
            )
        )
    }

    async extractGmeRpoSingleSelect(){

    }
    /**
     * Iterates through the RPO questions for GMEVin and displays them
     * @returns {*}
     */
    renderRpoQuestionsDth(){

        return(
            this.state.additionalRpoQuestions && this.state.additionalRpoQuestions.map((composite, compositeIndex)=>(
                <React.Fragment>
                    <label className={"RpoLabel"}>
                        {composite.label}
                    </label>
                    <div className={"DthPostRPOTableContainer"}>
                        <table>
                            {composite.selections.map((selection, index) =>(
                                <tr key = {index} id={"dthRpo"+composite+"-"+index}>
                                    <td onClick={async ()=>this.props.handleRpoQuestionClickDth(selection, index, await compositeIndex, this.additionalRpoHandler)}
                                        className={this.state.additionalRpoIndices[compositeIndex] === index ?
                                            "selectedRow" :"rpoTableRow"}>
                                        {selection}
                                    </td>
                                </tr>
                            ))}
                        </table>
                    </div>
                </React.Fragment>
            ))
        )
    }

    /**
     * When GEMVins have additional RpoQuestions, they get rendered
     * @returns {*}
     */
    renderAdditionalRpoQuestionsDth(){
        return(
            this.props.additionalRpoQuestions && this.props.additionalRpoQuestions.map((composite, compositeIndex)=>(
                <div className={"DthPostRPOTableContainer"} style={{position:'relative',
                    top:this.props.rpoLocations[compositeIndex].top,
                    left: this.props.rpoLocations[compositeIndex].left,
                }}>
                    <th>{composite.label}</th>
                    <table>
                    {composite.selections.map((selection, index) =>(
                        <tr key = {index}>
                            <td onClick={async ()=>this.props.handleRpoQuestionClickDth(selection, index, await compositeIndex, this.additionalRpoHandler)}
                                className={this.props.additionalRpoIndices[compositeIndex] === index ? "selectedRow" :"rpoTableRow"}>
                                {selection}
                            </td>
                        </tr>
                    ))}
                    </table>
                </div>
            ))
        )
    }


    componentDidMount() {
        if(this.props.adapterType === "NAOVin"){
            this.handleSingleRpoClickNao().then()
        }
        else if(this.props.adapterType === "GMEVin"){
            this.handleSingleRpoClickGme().then()
        }

    }

    async handleSingleRpoClickGme(){
        let gmeTables = document.getElementsByClassName("DthPostRPOTableContainer")
        let currentGmeTableContainer = gmeTables[gmeTables.length-1]
        if(currentGmeTableContainer !== null && currentGmeTableContainer !== undefined){
            let  currentGmeTable = currentGmeTableContainer.children[0]
            let tableElementCount = currentGmeTable.childElementCount
            if(tableElementCount === 1){
                let tableRow = currentGmeTable.children[0]
                let tableDat = tableRow.children[0]
                let isNotClicked = tableDat.getAttribute('clicked') === null
                if(isNotClicked){
                    tableDat.setAttribute('clicked', 'true')
                    tableDat.click()
                }
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.adapterType === "GMEVin") {
            this.handleSingleRpoClickGme().then()
        }
    }

    async additionalRpoHandler(questions, indices){
        await this.setState({
            additionalRpoQuestion: questions,
            additionalRpoIndices: indices,
        })
    }


    async handleSingleRpoClickNao(){
        if(this.props.postRpoQuestions.length > 1){
            return
        }
        let rpoRow = document.getElementById("rpo0")
        if(null !== rpoRow){
            rpoRow.click()
        }
    }
    /**
     * Main render method for RpoTable
     * @returns {*[]|*}
     */
    render(){
        if(this.props.adapterType === "NAOVin") {
            return (
                <div>
                    <label className={"RpoLabel"}>
                        {this.props.rpoLabel}
                    </label>
                    <div className={"PostRPOTableContainer"}>
                        <table>
                            {this.renderRpoQuestionsWsp()}
                        </table>
                    </div>
                </div>
            )
        }

        if(this.props.adapterType === "GMEVin"){
            return this.renderRpoQuestionsDth()
        }
    }
}

export default RpoTable